<template>
  <div>
    <h3 style="text-align: center">{{ $tc("demandeFaq.titre") }}</h3>
    <br>
    <v-row>
      <v-expansion-panels accordion>
        <v-expansion-panel
          v-for="faq in faqStore.faqs"
          :key="faq.id"
        >
          <v-expansion-panel-header><b style="font-size: 1rem">{{faq.question}}</b></v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-html='faq.reponse' />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import useFaqStore from '@/store/faqStore';

export default {
  name: 'FaqPrincipale',
  components: {
  },
  data() {
    return {
      faqs: [],
    };
  },
  setup() {
    const faqStore = useFaqStore();
    return { faqStore };
  },
  async created() {
    await this.faqStore.definirFaqs();
  },
};
</script>
